export default __webpack_public_path__ + "static/media/india2018B.63395b1a.jpg";